// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import getVisibleGroupedPathIds from './getVisibleGroupedPathIds'

// NOTE - because of the nested nature of
// groupedFrequencyPlans > paths > pathIds
// We need to determine if the individual groupedFrequencyPlans
// should render their headings based on wether or not
// any of that group's paths are even visible.
// In other places in this application we have stuff like
// visiblePathIds (an array of path ids)
// to tell a table how to render.
// But here, since we need to be able to conditionally render the parent
// based on the children, we will instead store a 2d array.
// the top level array represents the groups themselves.
// if a value.length === 0, then that group doesn't
// need to render at all.
// else the value is an array of path ids, then it will render the
// group's headings and it will render each path id in that array.

// eg.
// [
//   [1,3,6],
//   [],
//   [30]
// ]
// the first groupedFrequencyPlan renders its header and three paths
// the second will not display at all.
// the third renders its headings and only one path.

const getVisibleGroupedFrequencyPlans = visiblePathIds => (dispatch, getState) => {
  const groupedFrequencyPlans = getState().interferenceAnalysis.get('groupedFrequencyPlans')

  // makes the outer array for the grouped plans
  return groupedFrequencyPlans.reduce((a, d, i) => {
    // makes the inner array of path ids
    const groupsVisiblePathIds = getVisibleGroupedPathIds(d, visiblePathIds)

    a.push(groupsVisiblePathIds)

    return a
  }, [])
}

export default getVisibleGroupedFrequencyPlans
